// ...existing code...
// Chakra imports
import {
  Flex,
  Icon,
  Text,
  useColorModeValue,
  CircularProgress,
  Box,
  Divider,
} from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card";

// Assets
import {
  MdOutlineAccessible,
  MdOutlinePersonAddAlt1,
  MdOutlinePolicy,
  MdPeopleAlt,
  MdUnpublished,
} from "react-icons/md";
import { useEffect, useState } from "react";
import { listarGratuidade } from "config/apis/requests";
import PopOverAlertOrange from "components/popAlert/popAlert";
import { IsEmpty } from "config/functions";
import IconBox from "components/icons/IconBox";

export default function HistoricoGratuidade(props: {
  dataUser: any;
  historicoGratuidadeEstudanteCartao: any;
  historicoGratuidadeSeniorCartao: any;
  historicoGratuidadePcdCartao: any;
}) {
  const {
    dataUser,
    historicoGratuidadeEstudanteCartao,
    historicoGratuidadeSeniorCartao,
    historicoGratuidadePcdCartao,
  } = props;
  const blueIcon = useColorModeValue("blue.500", "white");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconBoxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const textGrayBg = useColorModeValue("secondaryGray.900", "navy.700");
  const textYelBg = useColorModeValue("yellow.500", "navy.300");
  const textVerdeBg = useColorModeValue("green.500", "navy.300");
  const textRedBg = useColorModeValue("red.500", "navy.300");
  const [historicoGratuidade, setHistoricoGratuidade] = useState([]);
  const [temHistorico, setTemHistorico] = useState(false);
  const [isOpenAlerta, setIsOpenAlerta] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const redIcon = useColorModeValue("red.500", "white");
  const handleOpenAlert = (status: boolean) => {
    setIsOpenAlerta(status);
  };

  const statusIcon = (status: any) => {
    switch (status) {
      case 1:
        return <Icon as={MdPeopleAlt} color={textYelBg} w="20px" h="18px" />;
      case 4:
        return (
          <Icon as={MdOutlinePolicy} color={textVerdeBg} w="20px" h="18px" />
        );
      case 3:
        return (
          <Icon as={MdOutlineAccessible} color={textGrayBg} w="20px" h="18px" />
        );
      case 2:
        return (
          <Icon
            as={MdOutlinePersonAddAlt1}
            color={textRedBg}
            w="20px"
            h="18px"
          />
        );
      default:
        return <Icon as={MdUnpublished} color={textRedBg} w="20px" h="18px" />;
    }
  };
  const descricaoCor = (status: any) => {
    switch (status) {
      case "Pendente":
        return (
          <Text color={textYelBg} fontSize="sm" fontWeight="700">
            Necessário confirmação de documentação
          </Text>
        );
      case "Solicitado":
        return (
          <Text color={blueIcon} fontSize="sm" fontWeight="700">
            Solicitada
          </Text>
        );
      case "Rejeitado":
        return (
          <Text color={textRedBg} fontSize="sm" fontWeight="700">
            Rejeitada
          </Text>
        );
      case "Cancelado":
        return (
          <Text color={redIcon} fontSize="sm" fontWeight="700">
            Cancelada
          </Text>
        );
      case "Aprovado":
        return (
          <Text color={textVerdeBg} fontSize="sm" fontWeight="700">
            Aprovado
          </Text>
        );

      case "Suspeita de fraude":
      case "Uso indevido":
        return (
          <Text color={redIcon} fontSize="sm" fontWeight="700">
            Suspeita de uso indevido
          </Text>
        );

      case "Uso indevido - Biometria":
        return (
          <Text color="orange.400" fontSize="sm" fontWeight="700">
            Suspeita de uso indevido - Biometria
          </Text>
        );

      case "Bloqueado":
        return (
          <Text color={redIcon} fontSize="sm" fontWeight="700">
            Bloqueada
          </Text>
        );

      case "Desbloqueado":
        return (
          <Text color={redIcon} fontSize="sm" fontWeight="700">
            Sem gratuidade
          </Text>
        );

      default:
        return (
          <Text color={textRedBg} fontSize="sm" fontWeight="700">
            Sem gratuidade
          </Text>
        );
    }
  };

  useEffect(() => {
    const fetchData = () => {
      setIsLoading(true);
      const list: any[] = [];

      const hasEstudante =
        historicoGratuidadeEstudanteCartao &&
        historicoGratuidadeEstudanteCartao !== "Gratuidade não existe!" &&
        historicoGratuidadeEstudanteCartao !== 500 &&
        historicoGratuidadeEstudanteCartao.length > 0;

      const hasPcd =
        historicoGratuidadePcdCartao &&
        historicoGratuidadePcdCartao !== "Gratuidade não existe!" &&
        historicoGratuidadePcdCartao !== 500 &&
        historicoGratuidadePcdCartao.length > 0;

      const hasSenior =
        historicoGratuidadeSeniorCartao &&
        historicoGratuidadeSeniorCartao !== "Gratuidade não existe!" &&
        historicoGratuidadeSeniorCartao !== 500 &&
        historicoGratuidadeSeniorCartao.length > 0;

      if (!hasEstudante && !hasPcd && !hasSenior) {
        setTemHistorico(false);
        setHistoricoGratuidade([]);
        setIsLoading(false);
        return;
      }

      // Estudante
      if (hasEstudante) {
        const maisRecente = historicoGratuidadeEstudanteCartao.reduce(
          (prev: any, curr: any) => {
            const prevDate = prev?.dataInclusao
              ? new Date(prev.dataInclusao)
              : null;
            const currDate = curr?.dataInclusao
              ? new Date(curr.dataInclusao)
              : null;
            if (!prevDate) return curr;
            if (!currDate) return prev;
            return currDate > prevDate ? curr : prev;
          },
          historicoGratuidadeEstudanteCartao[0]
        );
        const statusDescricao = maisRecente?.statusGratuidade?.descricao;
        const ultimoHistorico =
          maisRecente?.historicoStatusGratuidadeList?.[0];

        const motivo = ultimoHistorico?.descricao?.toLowerCase() || "";
        const ehBiometria = motivo.includes("biometria");

        let statusFinal = statusDescricao;

        if (statusDescricao === "Suspeita de fraude") {
          statusFinal = ehBiometria
            ? "Uso indevido - Biometria"
            : "Uso indevido";
        }

        list.push({
          statusGratuidade: statusFinal,
          descricaoGratuidade: " gratuidade PCD",
          idGratuidade: maisRecente?.tipoGratuidade?.id,
          descricaoStatusGratuidade: ultimoHistorico?.descricao || "",
        });
      }

      // PCD
      if (hasPcd) {
        const maisRecente = historicoGratuidadePcdCartao.reduce(
          (prev: any, curr: any) => {
            const prevDate = prev?.dataInclusao
              ? new Date(prev.dataInclusao)
              : null;
            const currDate = curr?.dataInclusao
              ? new Date(curr.dataInclusao)
              : null;
            if (!prevDate) return curr;
            if (!currDate) return prev;
            return currDate > prevDate ? curr : prev;
          },
          historicoGratuidadePcdCartao[0]
        );
        const statusDescricao = maisRecente?.statusGratuidade?.descricao;
        const ultimoHistorico =
          maisRecente?.historicoStatusGratuidadeList?.[0];

        const motivo = ultimoHistorico?.descricao?.toLowerCase() || "";
        const ehBiometria = motivo.includes("biometria");

        let statusFinal = statusDescricao;

        if (statusDescricao === "Suspeita de fraude") {
          statusFinal = ehBiometria
            ? "Uso indevido - Biometria"
            : "Uso indevido";
        }

        list.push({
          statusGratuidade: statusFinal,
          descricaoGratuidade: " gratuidade Estudante",
          idGratuidade: maisRecente?.tipoGratuidade?.id,
          descricaoStatusGratuidade: ultimoHistorico?.descricao || "",
        });
      }

      // Senior
      if (hasSenior) {
        const maisRecente = historicoGratuidadeSeniorCartao.reduce(
          (prev: any, curr: any) => {
            const prevDate = prev?.dataInclusao
              ? new Date(prev.dataInclusao)
              : null;
            const currDate = curr?.dataInclusao
              ? new Date(curr.dataInclusao)
              : null;
            if (!prevDate) return curr;
            if (!currDate) return prev;
            return currDate > prevDate ? curr : prev;
          },
          historicoGratuidadeSeniorCartao[0]
        );
        const statusDescricao = maisRecente?.statusGratuidade?.descricao;
        const ultimoHistorico =
          maisRecente?.historicoStatusGratuidadeList?.[0];

        const motivo = ultimoHistorico?.descricao?.toLowerCase() || "";
        const ehBiometria = motivo.includes("biometria");

        let statusFinal = statusDescricao;

        if (statusDescricao === "Suspeita de fraude") {
          statusFinal = ehBiometria
            ? "Uso indevido - Biometria"
            : "Uso indevido";
        }

        list.push({
          statusGratuidade: statusFinal,
          descricaoGratuidade: " gratuidade Sênior",
          idGratuidade: maisRecente?.tipoGratuidade?.id,
          descricaoStatusGratuidade: ultimoHistorico?.descricao || "",
        });
      }

      setHistoricoGratuidade(list);
      setTemHistorico(list.length > 0);
      setIsLoading(false);
    };

    fetchData();
  }, [
    historicoGratuidadeEstudanteCartao,
    historicoGratuidadeSeniorCartao,
    historicoGratuidadePcdCartao,
  ]);
  // ...existing code...
  return (
    <Card flexDirection="column" w="100%" {...dataUser} mb="20px">
      <PopOverAlertOrange
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpenAlerta}
        title="Ops..."
        subtitle="Digite um CPF válido!"
      />
      <Flex justify="space-between" px="10px" pt="5px" mb="25px" align="center">
        <Text
          color={textColor}
          fontSize="lg"
          fontWeight={"700"}
          lineHeight="100%"
        >
          Status gratuidades{" "}
        </Text>
      </Flex>
      <Divider mt="10px" />

      <Box
        position={"static"}
        overflowX="auto"
        overflowY={historicoGratuidade.length !== 0 ? "auto" : "hidden"}
        maxW="100vw"
        h={historicoGratuidade.length > 0 ? "200px" : "50px"}
        pb="17px"
      >
        {isLoading ? (
          <Flex justify="center" px="10px" pt="5px" mb="25px">
            <CircularProgress isIndeterminate color="green.300" size="40px" />
          </Flex>
        ) : !IsEmpty(historicoGratuidade) ? (
          historicoGratuidade.map((gratuidade, index) =>
            !IsEmpty(gratuidade.statusGratuidade) ? (
              <Flex
                key={index}
                justifyContent="center"
                mt="20px"
                alignItems="center"
                w="100%"
              >
                <IconBox
                  h="42px"
                  w="42px"
                  bg={iconBoxBg}
                  me="20px"
                  icon={statusIcon(gratuidade.idGratuidade)}
                />

                <Flex direction="column" align="start" me="auto">
                  <Text color={textGrayBg} fontSize="sm" fontWeight="500">
                    Tipo:{" "}
                    <b>{gratuidade.descricaoGratuidade ?? "Sem gratuidade"}</b>
                  </Text>
                  <Flex direction="row" align="start" me="auto">
                    <Text
                      color={textGrayBg}
                      fontSize="sm"
                      fontWeight="500"
                      mr={"3px"}
                    >
                      Status:
                    </Text>
                    {descricaoCor(gratuidade.statusGratuidade)}
                  </Flex>
                  {gratuidade.descricaoStatusGratuidade &&
                    gratuidade.statusGratuidade === "Pendente" && (
                      <Flex
                        direction="row"
                        me="auto"
                        alignContent={"center"}
                        justifySelf={"center"}
                      >
                        <Text
                          color={textGrayBg}
                          fontSize="sm"
                          fontWeight="500"
                          mr={"3px"}
                        >
                          Pendência:
                        </Text>

                        <Text
                          color={
                            gratuidade.statusGratuidade === "Pendente"
                              ? "red"
                              : textGrayBg
                          }
                          fontSize="sm"
                          fontWeight="500"
                          mr={"3px"}
                        >
                          {gratuidade.descricaoStatusGratuidade}
                        </Text>
                      </Flex>
                    )}
                </Flex>
              </Flex>
            ) : (
              <Flex
                key={index}
                justifyContent="center"
                mt="20px"
                alignItems="center"
                w="100%"
              >
                <IconBox
                  h="42px"
                  w="42px"
                  bg={iconBoxBg}
                  me="20px"
                  icon={statusIcon(gratuidade.idGratuidade)}
                />

                <Flex direction="column" align="start" me="auto">
                  <Text color={textGrayBg} fontSize="sm" fontWeight="500">
                    Tipo:{" "}
                    <b>{gratuidade.statusGratuidade ?? "Sem gratuidade"}</b>
                  </Text>
                  <Flex direction="row" align="start" me="auto">
                    <Text
                      color={textGrayBg}
                      fontSize="sm"
                      fontWeight="500"
                      mr={"3px"}
                    >
                      Status:
                    </Text>
                    {descricaoCor(gratuidade.statusGratuidade)}
                  </Flex>
                </Flex>
              </Flex>
            )
          )
        ) : (
          <Text
            fontSize="md"
            color={redIcon}
            fontWeight="500"
            align={"center"}
            mt={"15px"}
          >
            Sem dados disponíveis para pesquisa.{" "}
          </Text>
        )}
      </Box>
      <Divider mt="0px" />
    </Card>
  );
}
// ...existing code...
